var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.129703 14.0183C0.215913 14.1045 0.329092 14.1474 0.442271 14.1474C0.55545 14.1474 0.668629 14.1041 0.755281 14.0179L7.07385 7.6918L13.3924 14.0179C13.4786 14.1045 13.5918 14.1474 13.7054 14.1474C13.8186 14.1474 13.9318 14.1041 14.018 14.0183C14.1909 13.8459 14.1909 13.5661 14.0184 13.3932L7.70606 7.07374L14.018 0.754729C14.1904 0.581866 14.1904 0.302013 14.0176 0.129592C13.8442 -0.0432711 13.5648 -0.0432709 13.3924 0.130034L7.07341 6.45612L0.75484 0.130034C0.581976 -0.0428288 0.302124 -0.042829 0.129703 0.129592C-0.0431606 0.302013 -0.0431603 0.581866 0.129261 0.754729L6.44075 7.07374L0.129261 13.3932C-0.0431603 13.5656 -0.0431606 13.8459 0.129703 14.0183Z",
    fill: "#4B5258"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.065c4232a1a2574fa040302a4c98609c.svg";
export { ForwardRef as ReactComponent };